module.exports = __webpack_public_path__ + "img/beginner.74a039f1.png";